import { render } from "./ProductoListadoModal.vue?vue&type=template&id=064efbe4&scoped=true"
import script from "./ProductoListadoModal.vue?vue&type=script&lang=js"
export * from "./ProductoListadoModal.vue?vue&type=script&lang=js"

import "./ProductoListadoModal.vue?vue&type=style&index=0&id=064efbe4&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064efbe4"]])

export default __exports__